import { IUserProfile } from '@site-mate/sitemate-global-shared';

import { GlobalApiClient } from './global-api.client';

async function getUserById(userId: string): Promise<IUserProfile | null> {
  const res = await GlobalApiClient.post<IUserProfile>(`/private/user`, {
    userId,
  });

  if (res.status === 200) {
    return res.data;
  } else {
    return null;
  }
}

async function uploadSignature(dataUrl: string, fileName: string): Promise<{ url: string }> {
  const response = await fetch(dataUrl);
  const blob = await response.blob();

  const formData = new FormData();
  formData.append('type', 'signature');
  formData.append('signature-file', blob, fileName);

  const res = await GlobalApiClient.post<{ url: string }>('/user/upload', formData);
  return res.data;
}

export const userService = {
  getUserById,
  uploadSignature,
};
